
import { useState } from "react";
import { Row, Col, Modal } from "antd";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import { FaBars, FaFlag } from "react-icons/fa";
import { PRIMARY_COLOR } from "../../utils/colors";
import { useUser } from "../../contexts/User";

function Header({ onPress }) {
  const { user } = useUser()
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const { i18n, t } = useTranslation(); // Initialize translation

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language); // Change the language using i18n
    setIsModalVisible(false); // Close the modal after selection
  };

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}></Col>
        <Col span={24} md={18} className="header-control">
          <div
            className="d-flex align-items-center"
            style={{
              padding: "10px",
              background: "white",
              borderRadius: 25,
            }}
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: PRIMARY_COLOR,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "16px",
                color: "white",
                marginRight: "10px",
                border: `2px solid ${PRIMARY_COLOR}`,
              }}
            >
              {user.email.split('@')[0].split('.').map(name => name[0].toUpperCase()).join('')}
            </div>
            <h6 style={{ marginTop: 5 }}>{user.email.split('@')[0].toLowerCase()}</h6>
          </div>
          &nbsp;
          &nbsp;
          &nbsp;

          <button
            onClick={showModal}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <FaFlag color="green" /> <span style={{ color: PRIMARY_COLOR }}>{selectedLanguage}</span>
          </button>

          <button className="nav-toggle-btn"
            onClick={onPress}
            style={{ background: "none", border: "none", cursor: "pointer", color: PRIMARY_COLOR }}
          >
            <FaBars/>
          </button>
          
        </Col>
      </Row>

      {/* Modal */}
      <Modal
        title={t('Choose your language')}
        visible={isModalVisible}
        onCancel={handleCancel}
        centered
        width={300}
        footer={null}
      >
        <p>Chagua lugha / Hitamo nururimi / Sélectionnez la langue</p>

        <div className="row">
          <div className="col-md-12">
            <div
              className={`alert alert-default langContainer ${
                selectedLanguage === "en" ? "active" : ""
              }`}
              onClick={() => handleLanguageSelect("en")}
              style={{ cursor: "pointer" }}
            >
              <input
                type="radio"
                name="language"
                value="en"
                checked={selectedLanguage === "en"}
                readOnly
              />{" "}
              English
            </div>

            <div
              className={`alert alert-default langContainer ${
                selectedLanguage === "fr" ? "active" : ""
              }`}
              onClick={() => handleLanguageSelect("fr")}
              style={{ cursor: "pointer" }}
            >
              <input
                type="radio"
                name="language"
                value="fr"
                checked={selectedLanguage === "fr"}
                readOnly
              />{" "}
              Français
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Header;
